export const REINDEX_POLL_MS = 2000;
export const VENDOR_INDEX_RECENT_DONE_MS = 10000;
export const VENDOR_INDEX_WATCH_MS = 30000;

export function hasIndexingVendors(vendors = []) {
  return vendors.some((vendor) => vendor.phase === "INDEXING");
}

export function isVendorReindexRunning(vendors = [], vendorId) {
  const numericVendorId = Number(vendorId);
  return vendors.some(
    (vendor) => Number(vendor.vendorId) === numericVendorId && vendor.phase === "INDEXING",
  );
}

export function isAnyReindexRunning(full, vendors = []) {
  return Boolean(full?.running) || hasIndexingVendors(vendors);
}

export function shouldContinueReindexPolling({
  full,
  vendors = [],
  watchUntil = 0,
  now = Date.now(),
} = {}) {
  if (full?.running) {
    return true;
  }
  return shouldContinueVendorIndexPolling({ vendors, watchUntil, now });
}

export function selectVisibleVendors(
  vendors = [],
  recentDoneMs = VENDOR_INDEX_RECENT_DONE_MS
) {
  const now = Date.now();
  return vendors.filter((vendor) => {
    if (vendor.phase === "INDEXING") {
      return true;
    }
    return (
      vendor.finishedAt &&
      now - new Date(vendor.finishedAt).getTime() < recentDoneMs
    );
  });
}

export function shouldContinueVendorIndexPolling({
  vendors = [],
  watchUntil = 0,
  now = Date.now(),
} = {}) {
  if (hasIndexingVendors(vendors)) {
    return true;
  }
  return watchUntil > now;
}
